var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.76 62.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Naamloos_verloop_90);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        opacity: .85;\n      }\n\n      .cls-3 {\n        fill: url(#Naamloos_verloop_39);\n      }\n\n      .cls-4 {\n        fill: url(#Naamloos_verloop_39-3);\n      }\n\n      .cls-5 {\n        fill: url(#Naamloos_verloop_39-4);\n      }\n\n      .cls-6 {\n        fill: url(#Naamloos_verloop_39-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_39",
    "data-name": "Naamloos verloop 39",
    x1: 23.95,
    y1: 33.08,
    x2: 55.85,
    y2: 33.08,
    gradientTransform: "translate(-14.7 66.16) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e0e0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_39-2",
    "data-name": "Naamloos verloop 39",
    x1: 30.31,
    y1: 1.76,
    x2: 43.15,
    y2: 1.76,
    gradientTransform: "translate(58.76) rotate(-180) scale(1 -1)",
    xlinkHref: "#Naamloos_verloop_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_39-3",
    "data-name": "Naamloos verloop 39",
    x1: 30.31,
    y1: 3.5,
    x2: 43.15,
    y2: 3.5,
    gradientTransform: "translate(58.76) rotate(-180) scale(1 -1)",
    xlinkHref: "#Naamloos_verloop_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_39-4",
    "data-name": "Naamloos verloop 39",
    x1: 30.31,
    y1: 5.23,
    x2: 43.15,
    y2: 5.23,
    gradientTransform: "translate(58.76) rotate(-180) scale(1 -1)",
    xlinkHref: "#Naamloos_verloop_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_90",
    "data-name": "Naamloos verloop 90",
    x1: 22.54,
    y1: 34.03,
    x2: 51.93,
    y2: 34.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ee7082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f06479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f4516a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f93654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.83,
    y: 3.5,
    width: 30.41,
    height: 59.17,
    rx: 5.02,
    ry: 5.02,
    transform: "translate(44.07 66.16) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M15.62,3.5v-1.28c0-1.21.98-2.19,2.19-2.19h8.46c1.21,0,2.19.98,2.19,2.19v1.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 28.45,
    y1: 3.5,
    x2: 15.62,
    y2: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.45,4.77c0,1.21-.98,2.19-2.19,2.19h-8.46c-1.21,0-2.19-.98-2.19-2.19v-1.28h12.83v1.28Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.41,11.17c-.24,0-.48.2-.53.44l-5.32,25.1c-.07.35.19.68.54.68h7.79c.24,0,.41.2.37.44l-2.96,18.84c-.04.25.06.29.21.1l23.35-28.88c.15-.19.08-.35-.16-.35h-11.15c-.24,0-.36-.18-.26-.41l6.66-15.55c.1-.23-.02-.41-.27-.41h-18.26Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBattery);
export default __webpack_public_path__ + "static/media/icon_battery.654e4cf5de76f9e19fcbdaa410004c7b.svg";
export { ForwardRef as ReactComponent };